
import Vue from 'vue';

import ViewTicketList from './components/ticket/ViewTicketList';
Vue.component(ViewTicketList.name, ViewTicketList);

import TicketUser from './components/ticket/TicketUser';
Vue.component(TicketUser.name, TicketUser);

import TicketTaskForm from './components/ticket/TicketTaskForm';
Vue.component(TicketTaskForm.name, TicketTaskForm);

import TicketTaskFormItem from './components/ticket/TicketTaskFormItem';
Vue.component(TicketTaskFormItem.name, TicketTaskFormItem);

import TicketType from './components/ticket/TicketType';
Vue.component(TicketType.name, TicketType);

import TicketTitle from './components/ticket/TicketTitle';
Vue.component(TicketTitle.name, TicketTitle);

import TicketReply from './components/ticket/TicketReply';
Vue.component(TicketReply.name, TicketReply);

import TicketShare from './components/ticket/TicketShare';
Vue.component(TicketShare.name, TicketShare);

import TicketMark from './components/ticket/TicketMark';
Vue.component(TicketMark.name, TicketMark);

import TicketDetailLeft from './components/ticket/TicketDetailLeft';
Vue.component(TicketDetailLeft.name, TicketDetailLeft);

import TicketDetailRight from './components/ticket/TicketDetailRight';
Vue.component(TicketDetailRight.name, TicketDetailRight);

import TicketTag from './components/ticket/TicketTag';
Vue.component(TicketTag.name, TicketTag);

import TicketUpload from './components/ticket/TicketUpload';
Vue.component(TicketUpload.name, TicketUpload);

import TicketUploadList from './components/ticket/TicketUploadList';
Vue.component(TicketUploadList.name, TicketUploadList);

import NoticeUserSearch from './components/ticket/NoticeUserSearch';
Vue.component(NoticeUserSearch.name, NoticeUserSearch);

import DealUserSearch from './components/ticket/DealUserSearch';
Vue.component(DealUserSearch.name, DealUserSearch);

import MerchantOrderSearch from './components/ticket/MerchantOrderSearch';
Vue.component(MerchantOrderSearch.name, MerchantOrderSearch);

import TicketDashboard from './components/ticket/TicketDashboard';
Vue.component(TicketDashboard.name, TicketDashboard);

import DashboardTicketTable from './components/ticket/DashboardTicketTable';
Vue.component(DashboardTicketTable.name, DashboardTicketTable);

import TicketBottom from './components/ticket/TicketBottom';
Vue.component(TicketBottom.name, TicketBottom);

import TicketWorkflowSelect from './components/ticket/TicketWorkflowSelect';
Vue.component(TicketWorkflowSelect.name, TicketWorkflowSelect);

import TicketTemplateSelect from './components/ticket/TicketTemplateSelect';
Vue.component(TicketTemplateSelect.name, TicketTemplateSelect);

import NewTicketDialog from './components/ticket/NewTicketDialog';
Vue.component(NewTicketDialog.name, NewTicketDialog);

import LoadFormData from './components/ticket/LoadFormData';
Vue.component(LoadFormData.name, LoadFormData);

import UserNotifyConfigDialog from './components/ticket/UserNotifyConfigDialog';
Vue.component(UserNotifyConfigDialog.name, UserNotifyConfigDialog);

import AssignToWorkflowDialog from './components/ticket/AssignToWorkflowDialog';
Vue.component(AssignToWorkflowDialog.name, AssignToWorkflowDialog);

import UserNotifyConfigTable from './components/ticket/UserNotifyConfigTable';
Vue.component(UserNotifyConfigTable.name, UserNotifyConfigTable);

import TicketSolveDialog from './components/ticket/TicketSolveDialog';
Vue.component(TicketSolveDialog.name, TicketSolveDialog);

import TicketAssignDialog from './components/ticket/TicketAssignDialog';
Vue.component(TicketAssignDialog.name, TicketAssignDialog);

import TicketEventList from './components/ticket/TicketEventList';
Vue.component(TicketEventList.name, TicketEventList);

import ReplyTicketButton from './components/ticket/ReplyTicketButton';
Vue.component(ReplyTicketButton.name, ReplyTicketButton);

import TicketTypeCascader from './components/ticket/TicketTypeCascader';
Vue.component(TicketTypeCascader.name, TicketTypeCascader);

import TicketTaskFormDialog from './components/ticket/TicketTaskFormDialog';
Vue.component(TicketTaskFormDialog.name, TicketTaskFormDialog);

import MerchantSearch from './components/ticket/MerchantSearch';
Vue.component(MerchantSearch.name, MerchantSearch);

import LineSearch from './components/ticket/LineSearch';
Vue.component(LineSearch.name, LineSearch);

import TicketSearch from './components/ticket/TicketSearch';
Vue.component(TicketSearch.name, TicketSearch);

import MerchantOrderSearchComplex from './components/ticket/MerchantOrderSearchComplex';
Vue.component(MerchantOrderSearchComplex.name, MerchantOrderSearchComplex);

import TicketTitleByNo from './components/ticket/TicketTitleByNo';
Vue.component(TicketTitleByNo.name, TicketTitleByNo);

import ViewTicketCount from './components/ticket/ViewTicketCount';
Vue.component(ViewTicketCount.name, ViewTicketCount);

import TicketWidgetSegment from './components/ticket/TicketWidgetSegment';
Vue.component(TicketWidgetSegment.name, TicketWidgetSegment);

import TicketContactUser from './components/ticket/TicketContactUser';
Vue.component(TicketContactUser.name, TicketContactUser);

import TicketFormOperationBar from './components/ticket/TicketFormOperationBar';
Vue.component(TicketFormOperationBar.name, TicketFormOperationBar);

import ViewTicketTableColumn from './components/ticket/ViewTicketTableColumn';
Vue.component(ViewTicketTableColumn.name, ViewTicketTableColumn);

import ViewTicketTable from './components/ticket/ViewTicketTable';
Vue.component(ViewTicketTable.name, ViewTicketTable);

import TicketSearchForm from './components/ticket/TicketSearchForm';
Vue.component(TicketSearchForm.name, TicketSearchForm);

import WorkflowSelect from './components/ticket/WorkflowSelect';
Vue.component(WorkflowSelect.name, WorkflowSelect);

import TicketQRCodeDialog from './components/ticket/TicketQRCodeDialog';
Vue.component(TicketQRCodeDialog.name, TicketQRCodeDialog);

import TicketWidget from './components/ticket/TicketWidget';
Vue.component(TicketWidget.name, TicketWidget);

import TicketWidgetCSS from './components/ticket/TicketWidgetCSS';
Vue.component(TicketWidgetCSS.name, TicketWidgetCSS);

import TicketWidgetJS from './components/ticket/TicketWidgetJS';
Vue.component(TicketWidgetJS.name, TicketWidgetJS);

import TicketWidgetRightField from './components/ticket/TicketWidgetRightField';
Vue.component(TicketWidgetRightField.name, TicketWidgetRightField);

import TicketWidgetLiteral from './components/ticket/TicketWidgetLiteral';
Vue.component(TicketWidgetLiteral.name, TicketWidgetLiteral);

import TicketWidgetTopLeftTab from './components/ticket/TicketWidgetTopLeftTab';
Vue.component(TicketWidgetTopLeftTab.name, TicketWidgetTopLeftTab);

import TicketWidgetNewButton from './components/ticket/TicketWidgetNewButton';
Vue.component(TicketWidgetNewButton.name, TicketWidgetNewButton);

import TicketOrigin from './components/ticket/TicketOrigin';
Vue.component(TicketOrigin.name, TicketOrigin);

import UserAgent from './components/ticket/UserAgent';
Vue.component(UserAgent.name, UserAgent);

import TicketWidgetLinkButton from './components/ticket/TicketWidgetLinkButton';
Vue.component(TicketWidgetLinkButton.name, TicketWidgetLinkButton);

import TicketFormCheckbox from './components/ticket/TicketFormCheckbox';
Vue.component(TicketFormCheckbox.name, TicketFormCheckbox);

import TicketFormDistrict from './components/ticket/TicketFormDistrict';
Vue.component(TicketFormDistrict.name, TicketFormDistrict);

import TicketFormRadio from './components/ticket/TicketFormRadio';
Vue.component(TicketFormRadio.name, TicketFormRadio);

import TicketFormSwitch from './components/ticket/TicketFormSwitch';
Vue.component(TicketFormSwitch.name, TicketFormSwitch);

import TicketFormShop from './components/ticket/TicketFormShop';
Vue.component(TicketFormShop.name, TicketFormShop);

import TicketWidgetMyTicketList from './components/ticket/TicketWidgetMyTicketList';
Vue.component(TicketWidgetMyTicketList.name, TicketWidgetMyTicketList);

import UserLatestTicket from './components/ticket/UserLatestTicket';
Vue.component(UserLatestTicket.name, UserLatestTicket);

import TicketWidgetNewCenterContent from './components/ticket/TicketWidgetNewCenterContent';
Vue.component(TicketWidgetNewCenterContent.name, TicketWidgetNewCenterContent);

import TicketDetailReplyForm from './components/ticket/TicketDetailReplyForm';
Vue.component(TicketDetailReplyForm.name, TicketDetailReplyForm);

import SubmitTicketButton from './components/ticket/SubmitTicketButton';
Vue.component(SubmitTicketButton.name, SubmitTicketButton);

import CurrentUser from './components/ticket/CurrentUser';
Vue.component(CurrentUser.name, CurrentUser);

import TicketFormSlider from './components/ticket/TicketFormSlider';
Vue.component(TicketFormSlider.name, TicketFormSlider);

import TicketFormRate from './components/ticket/TicketFormRate';
Vue.component(TicketFormRate.name, TicketFormRate);

import TicketFormAuth from './components/ticket/TicketFormAuth';
Vue.component(TicketFormAuth.name, TicketFormAuth);

import TicketWidgetCallInfo from './components/ticket/TicketWidgetCallInfo';
Vue.component(TicketWidgetCallInfo.name, TicketWidgetCallInfo);

import TicketWidgetGroup from './components/ticket/TicketWidgetGroup';
Vue.component(TicketWidgetGroup.name, TicketWidgetGroup);

import TicketMailSendDialog from './components/ticket/TicketMailSendDialog';
Vue.component(TicketMailSendDialog.name, TicketMailSendDialog);

import TicketBatchOperationBar from './components/ticket/TicketBatchOperationBar';
Vue.component(TicketBatchOperationBar.name, TicketBatchOperationBar);

import TicketWidgetRelated from './components/ticket/TicketWidgetRelated';
Vue.component(TicketWidgetRelated.name, TicketWidgetRelated);

import NewTicketRelated from './components/ticket/NewTicketRelated';
Vue.component(NewTicketRelated.name, NewTicketRelated);

import WorkWeixingetApprovalDialog from './components/ticket/WorkWeixingetApprovalDialog';
Vue.component(WorkWeixingetApprovalDialog.name, WorkWeixingetApprovalDialog);

import WorkWeixinRelatedApproval from './components/ticket/WorkWeixinRelatedApproval';
Vue.component(WorkWeixinRelatedApproval.name, WorkWeixinRelatedApproval);

import TicketStatusSelect from './components/ticket/TicketStatusSelect';
Vue.component(TicketStatusSelect.name, TicketStatusSelect);

import ProjectIndex from './components/ticket/ProjectIndex';
Vue.component(ProjectIndex.name, ProjectIndex);

import ProjectSearch from './components/ticket/ProjectSearch';
Vue.component(ProjectSearch.name, ProjectSearch);

import ProjectChildrenCount from './components/ticket/ProjectChildrenCount';
Vue.component(ProjectChildrenCount.name, ProjectChildrenCount);

import ProjectTicketCount from './components/ticket/ProjectTicketCount';
Vue.component(ProjectTicketCount.name, ProjectTicketCount);

import TicketProjectSelect from './components/ticket/TicketProjectSelect';
Vue.component(TicketProjectSelect.name, TicketProjectSelect);

import ProjectTree from './components/ticket/ProjectTree';
Vue.component(ProjectTree.name, ProjectTree);

import TicketExportButton from './components/ticket/TicketExportButton';
Vue.component(TicketExportButton.name, TicketExportButton);

import TicketSplitDialog from './components/ticket/TicketSplitDialog';
Vue.component(TicketSplitDialog.name, TicketSplitDialog);

import TicketFormPhoneVerified from './components/ticket/TicketFormPhoneVerified';
Vue.component(TicketFormPhoneVerified.name, TicketFormPhoneVerified);

import TicketViewMain from '@/components/ticket/TicketViewMain';
Vue.component(TicketViewMain.name, TicketViewMain);

import RecentTicketEvent from '@/components/ticket/RecentTicketEvent';
Vue.component(RecentTicketEvent.name, RecentTicketEvent);

import TicketEventVisibleSwitch from '@/components/ticket/TicketEventVisibleSwitch';
Vue.component(TicketEventVisibleSwitch.name, TicketEventVisibleSwitch);

import LinkedTicketList from '@/components/ticket/LinkedTicketList';
Vue.component(LinkedTicketList.name, LinkedTicketList);

import AssignToWorkflowButton from '@/components/ticket/AssignToWorkflowButton';
Vue.component(AssignToWorkflowButton.name, AssignToWorkflowButton);

import UserNotifyConfigSwitch from '@/components/ticket/UserNotifyConfigSwitch';
Vue.component(UserNotifyConfigSwitch.name, UserNotifyConfigSwitch);

import UserTicketEventList from '@/components/ticket/UserTicketEventList';
Vue.component(UserTicketEventList.name, UserTicketEventList);

import UserTicketList from '@/components/ticket/UserTicketList';
Vue.component(UserTicketList.name, UserTicketList);

import FormInlineMode from '@/components/ticket/FormInlineMode';
Vue.component(FormInlineMode.name, FormInlineMode);



// WEBPACK FOOTER //
// ./src/components-ticket.js